import axios, { AxiosRequestConfig } from "axios";
import { format } from "date-fns";
import { ApiError } from "./ApiError";

axios.defaults.withCredentials = true;
axios.defaults.xsrfHeaderName = 'X-CSRF-Token'

export type ReserveType = "STORE" | "STORE_PAD" | "MYPAGE_PC" | "MYPAGE_MOBILE" | "OTHER"
export type CountRange = "monthly" | "daily"

export interface getReserveTypeCountProps {
    str_id: number
    reserve_type: ReserveType
    date: Date
    count_range: CountRange
}
export interface getReserveTypeCountResults {
    count: number
}
export const getReserveTypeCount = async ({
    str_id,
    reserve_type,
    date,
    count_range,
}: getReserveTypeCountProps, config?: AxiosRequestConfig): Promise<getReserveTypeCountResults> => {
    try {
        let params = new URLSearchParams()
        params.append("str_id", str_id.toString())
        params.append("reserve_type", reserve_type)
        switch (count_range) {
            case "monthly":
                params.append("month", format(date, "yyyy-MM"))
                break;
            default:
                params.append("date", format(date, "yyyy-MM-dd"))
                break;
        }

        let res = await axios.post(
            process.env.REACT_APP_API_ENDPOINT + 'reserve/get_reserve_type_count',
            params, config
        )
        if (res.data.status !== 'SUCCESS') {
            throw new ApiError(res.data.message ? res.data.message : "サーバーエラー", res.data.status)
        }
        return {
            count: parseInt(res.data.count)
        }
    } catch (error) {
        throw error
    }
}